@if (showSpinner) {
  <app-loader></app-loader>
}
<main class="content-wrapper" [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
  <div class="container-fluid mb-4">
    <div class="row for_row_rearrange" [ngClass]="{ 'dark-text': selectedMode === 'dark' }">
      <div class="col-4 p-3">
        <h3 class="font-weight-bold">
          {{data.data.first_name}} {{data.data.last_name}}
        </h3>
        <h6 class="font-weight-bold text-black-50" [ngClass]="{ 'dark-text': selectedMode === 'dark' }">
          {{data.data.description}}
        </h6>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-8 col-sm-12 col-12 shadow" style="margin-top: 30px">


        <form #f="ngForm" (ngSubmit)="onSubmit(f)">
          <table class="table table-bordered">
            <tbody>

              <tr class="card-body text-white " style=" background-color: #112a5f"
                [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
                <th>KP Description</th>
                <th>KP Values</th>
                <th>TL Rating</th>
                <th>PM Rating</th>
              </tr>
              @for (item of kpValues; track item; let i = $index) {
                <tr
                  [ngClass]="{ 'dark-backround-tr': selectedMode === 'dark' }">
                  <th>{{item.title}}</th>
                  <td style="width: 15%">{{item.value}}</td>
                  <td style="width: 15%">
                    <input type="number" class="form-control" name="rating{{i}}" [(ngModel)]="rating[i]"
                      (input)="onInputChangeRating()" #numberFieldInput1="ngModel" [min]="minValues[i]"
                      [max]="maxValues[i]" [readOnly]="roleType === 'Admin'" />
                      @if (numberFieldInput1.invalid && (numberFieldInput1.dirty || numberFieldInput1.touched)) {
                        <div>
                          @if (numberFieldInput.hasError('min')) {
                            <div style="color: red; font-size: x-small;">Value >= <b>{{
                            minValues[i] }}</b></div>
                          }
                          @if (numberFieldInput.hasError('max')) {
                            <div style="color: red; font-size: x-small;">Value <= <b>{{
                            maxValues[i] }}</b></div>
                          }
                        </div>
                      }
                    </td>
                    <td style="width: 15%">
                      <input type="number" class="form-control" name="pm_rating{{i}}" [(ngModel)]="pm_rating[i]"
                        (input)="onInputChange()" #numberFieldInput="ngModel" [min]="minValues[i]" [max]="maxValues[i]"
                        [readOnly]="roleType === 'Team_Lead'" />
                        @if (numberFieldInput.invalid && (numberFieldInput.dirty || numberFieldInput.touched)) {
                          <div>
                            @if (numberFieldInput.hasError('min')) {
                              <div style="color: red; font-size: x-small;">Value >= <b>{{
                              minValues[i] }}</b></div>
                            }
                            @if (numberFieldInput.hasError('max')) {
                              <div style="color: red; font-size: x-small;">Value <= <b>{{
                              maxValues[i] }}</b></div>
                            }
                          </div>
                        }
                      </td>
                    </tr>
                  }
                  <tr [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
                    <th>Evaluation Date</th>
                    <td colspan="3">
                      <input type="date" name="ev_date" id="ev_date" [(ngModel)]="getDate" ngModel #start_date="ngModel"
                        class="form-control date-type" id="datetimepicker4" [readOnly]="roleType === 'Team_Lead'" />
                      </td>

                    </tr>
                    @if (roleType === 'Admin' ) {
                      <tr [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
                        <th>Do You Want To Publish User Evaluation ?</th>
                        <td colspan="3 d-flex">
                          <div class="col-6">
                            <input type="radio" name="publish" value="1" [(ngModel)]="publishValue">
                            <label class="publish" [ngClass]="{ 'dark-publish': selectedMode === 'dark' }">Yes</label>
                          </div>
                          <div class="col-6">
                            <input type="radio" name="publish" value="0" [(ngModel)]="publishValue">
                            <label class="publish" [ngClass]="{ 'dark-publish': selectedMode === 'dark' }">No</label>
                          </div>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>

                @if (roleType === 'Team_Lead' && publishValue1 !== '1') {
                  <div class="media d-flex text-secondary-light mb-5 time-detail col-12"
                    >
                    <div class="col-6">
                      <button type="button" class="btn btn float-right cancel" (click)="cancel()">Cancel</button>
                    </div>
                    <div class="col-6">
                      <button type="submit" class="btn btn apply">Save</button>
                    </div>
                  </div>
                }
                @if ( roleType === 'Admin') {
                  <div class="media d-flex text-secondary-light mb-5 time-detail col-12">
                    <div class="col-6">
                      <button type="button" class="btn btn float-right cancel" (click)="cancel()">Cancel</button>
                    </div>
                    <div class="col-6">
                      <button type="submit" class="btn btn apply">Save</button>
                    </div>
                  </div>
                }
              </form>
            </div>

            <div class="col-xl-4 col-sm-12 col-12" style="margin-top: 30px">
              <div class="card">
                <div class="card-content rounded">
                  <div class="card-body rounded-top" style="background-color: #7cdb80"
                    [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
                    <div class="media text-center text-white font-weight-normal" style="font-size: 20px">
                      <div class="col">
                        <span class="text float-left">Band Range</span>
                        <span class="text float-right">Band Value</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <table class="table table-bordered" [ngClass]="{ 'dark-backround-tr': selectedMode === 'dark' }">
                <thead>
                  <tr [ngClass]="{'bandColor': band1}">
                    <th>0%-25%</th>
                    <td>1</td>
                  </tr>
                </thead>
                <tbody>
                  <tr [ngClass]="{'bandColor1': band2}">
                    <th>25%-50%</th>
                    <td>2</td>
                  </tr>
                  <tr [ngClass]="{'bandColor2': band3}">
                    <th>50%-75%</th>
                    <td>3</td>
                  </tr>
                  <tr [ngClass]="{'bandColor3': band4}">
                    <th>75%-100%</th>
                    <td>4</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </main>